import { render, staticRenderFns } from "./DescargarNumerosTalonarios.vue?vue&type=template&id=2fe9a864"
import script from "./DescargarNumerosTalonarios.vue?vue&type=script&lang=js"
export * from "./DescargarNumerosTalonarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports